<template>

    <KedvezmenyekBase>

        <v-layout row wrap  slot="kedvezmeny" ref="kedvezmeny" style="max-width: 100%;">

            <BnFormField v-if="union24Visible" :attributes="union24" />

            <BnFormField v-if="flottaVisible" :attributes="flotta" />

            <BnFormField v-if="supershopVisible" :attributes="supershop" />

            <BnFormField v-if="egyuttCascoVisible" :attributes="egyuttcasco"  />

            <BnFormField v-if="futasteljesitmenyVisible" :attributes="futasteljesitmeny" />

            <BnFormField v-if="drivelloVisible" :attributes="drivello" />

            <BnFormField v-if="drivellorendszamVsibile" :attributes="drivellorendszam" />

        </v-layout>

    </KedvezmenyekBase>

</template>

<script>
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import KedvezmenyekBase from '../KedvezmenyBase.vue';
import TariffAnnouncementUtils from '../../../../../../../utils/TariffAnnouncementUtils';
import toupper from '../../../../../../../filters/toupper';
import nospecial from '../../../../../../../filters/nospecial';

export default {
    name: 'KedvezmenyekB11',
    components: { BnFormField, KedvezmenyekBase },
    mixins: [Kedvezmeny],
    mounted() {
        this.union24IsOn = this.$store.getters.kedvezmenyekbiztosito['11']?.union24 === true;
    },
    computed: {
        union24Visible() {
            return TariffAnnouncementUtils.isKockakezdetLesser(2023, 'kgfb', this.$store);
        },
        flottaVisible() {
            return this.union24IsOn === false && this.isSZGK()
                && TariffAnnouncementUtils.isKockakezdetLesser(2023, 'kgfb', this.$store);
        },
        supershopVisible() {
            return this.union24IsOn === true && this.isSZGK()
                && +this.$store.getters.tarifaData.ajanl_kock_kezd < 20250601;
        },
        egyuttCascoVisible() {
            return this.isSZGK() && this.isTermeszetesSzemely()
                && +this.$store.getters.tarifaData.ajanl_kock_kezd < 20240808;
        },
        futasteljesitmenyVisible() {
            return ((
                    this.$store.getters.tarifaData.ajanl_generalicascofull === '0-5000'
                    && this.$store.getters.tarifaData.kulfoldi_futasteljesitmeny === '0-5000'
                ) || (
                    this.$store.getters.tarifaData.ajanl_generalicascofull === '5001-10000'
                    && this.$store.getters.tarifaData.kulfoldi_futasteljesitmeny === '0-5000'
                ) || (
                    this.$store.getters.tarifaData.ajanl_generalicascofull === '0-5000'
                    && this.$store.getters.tarifaData.kulfoldi_futasteljesitmeny === '5001-10000'
                ))
                && this.isSZGK()
                && +this.$store.getters.tarifaData.ajanl_kock_kezd < 20241212;
        },
        drivelloVisible() {
            return this.isSZGK()
                && this.isTermeszetesSzemely()
                && this.$store.getters.tarifaData.allianzemail
                && TariffAnnouncementUtils.isKockakezdetEqualOrGreater(2026, 'kgfb', this.$store);
        },
        drivellorendszamVsibile() {
            return this.drivelloVisible && this.getValue('kedvezmenyekbiztosito.11.drivello') === true;
        },
    },
    methods: {
        union24Change(event) {
            this.shouldRecalc();
            this.$store.commit('setProp', {
                path: 'kedvezmenyekbiztosito.11.supershop',
                value: false,
            });
            this.$store.commit('setProp', {
                path: 'kedvezmenyekbiztosito.11.flotta',
                value: false,
            });
            this.union24IsOn = event;
        },
    },
    data() {
        return {
            union24IsOn: false,
            egyuttcasco: {
                type: 'checkbox',
                label: 'CASCO együttkötés kedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                mezo: 'union_egyuttcasco',
                change: this.shouldRecalc,
                path: 'kedvezmenyekbiztosito.11.egyuttcasco',
            },
            union24: {
                type: 'checkbox',
                label: 'Union24 kedvezmény',
                visible: true,
                editable: !this.disabled,
                mezo: 'union_union24',
                path: 'kedvezmenyekbiztosito.11.union24',
                help: true,
                change: this.union24Change,
            },
            supershop: {
                type: 'checkbox',
                label: 'Supershop kártya kedvezmény',
                visible: true,
                editable: !this.disabled,
                mezo: 'union_supershop',
                path: 'kedvezmenyekbiztosito.11.supershop',
                help: true,
                change: this.shouldRecalc,
                removeValOnDestroy: true,
            },
            autoklub: {
                type: 'checkbox',
                label: 'Magyar Autóklub kedvezmény',
                visible: true,
                editable: !this.disabled,
                mezo: 'union_autoklub',
                path: 'kedvezmenyekbiztosito.11.autoklub',
                help: true,
                change: this.shouldRecalc,
                removeValOnDestroy: true,
            },
            flotta: {
                type: 'checkbox',
                label: 'Családi flotta kedvezmény',
                visible: true,
                editable: !this.disabled,
                mezo: 'union_flotta',
                path: 'kedvezmenyekbiztosito.11.flotta',
                help: true,
                change: this.shouldRecalc,
                removeValOnDestroy: true,
            },
            futasteljesitmeny: {
                type: 'checkbox',
                label: 'Kevesebb, mint 10.000 km futásteljesítmény',
                visible: true,
                editable: !this.disabled,
                mezo: 'union_futasteljesitmeny',
                path: 'kedvezmenyekbiztosito.11.futasteljesitmeny',
                help: true,
                change: this.shouldRecalc,
            },
            drivello: {
                type: 'checkbox',
                label: 'Drivello',
                visible: true,
                editable: !this.disabled,
                mezo: 'drivello',
                path: 'kedvezmenyekbiztosito.11.drivello',
                help: true,
                change: this.shouldRecalc,
                removeValOnDestroy: true,
            },
            drivellorendszam: {
                type: 'text',
                label: 'Drivello rendszám',
                visible: true,
                editable: !this.disabled,
                mezo: 'drivellorendszam',
                path: 'kedvezmenyekbiztosito.11.drivellorendszam',
                help: true,
                change: this.shouldRecalc,
                removeValOnDestroy: true,
                textTransform: (v) => toupper(nospecial(v)),
            },
        };
    },
};
</script>
